import { useEffect } from "react";
import { UpdateAccountErrorKeys, UpdateAccountErrorListKeys } from "../../login/components/UpdateAccountSection";
import { useConversion } from "./use.analytics";

interface UpdateAccountAnalyticsProps {
 analyticsKey?: UpdateAccountErrorKeys | UpdateAccountErrorListKeys | "unknownError" 
 conversion: ReturnType<typeof useConversion> | null

}

export const useUpdateAccountAnalytics = (props: UpdateAccountAnalyticsProps) => {
    const {analyticsKey, conversion} = props;
    useEffect(() => {
        const errorKeyToMessage: {
          [key in UpdateAccountErrorKeys | UpdateAccountErrorListKeys | "unknownError"]: string
        } = {
            inconvenience: "We're sorry for any inconvenience. Try updating your account later.",
            tryToLog: "Your account is now locked to protect your information. You can try to log in again in 1 hour.",
            oneMoreTry: "You have 1 more try to re-enter your username and password. If it doesn't match our records, your account will be locked for 1 hour.",
            tryAgain: "Check the information you entered and try again.",
            passwordGuidelines: "The Password does not meet the required guidelines. Please enter the correct information and try again.",
            unknownError: 'unknown error',
            checkPassword: "Check your current password.",
            enterPassword: "Enter a new password that's different from your last 6 passwords.",
            createPassword: "Create a password for your account using the guidelines listed.",
            enterEmail: 'Enter your email address or select "I don\'t have an email address."',
            createUsername: "Create a username for your account using the guidelines listed.",
            alreadyUsed: "This username is already being used by someone else. Try creating another username, using the guidelines listed.",
            question: "Select a secret question.",
            answer: "Enter the answer to your secret question.",
        }
        if (analyticsKey) {
            conversion && conversion.failAPI(analyticsKey ? errorKeyToMessage[analyticsKey] : '');
        }
    }, [conversion, analyticsKey]);

}